import { useEffect } from "react";
import DataGridInstance from "devextreme/ui/data_grid";
import dxDataGrid from "devextreme/ui/data_grid";

export function useClearGridSelectionOnHeaderUncheck(
  gridId: string,
  activate: boolean
) {
  useEffect(() => {
    if (!activate) return;
    const gridElement = document.getElementById(gridId);
    if (!gridElement) return;

    const handleClick = () => {
      setTimeout(() => {
        const headerCheckbox = gridElement.querySelector(
          ".dx-header-row .dx-select-checkbox"
        ) as HTMLElement;

        const isUnchecked = !headerCheckbox?.classList.contains(
          "dx-checkbox-checked"
        );

        if (isUnchecked) {
          const grid = DataGridInstance.getInstance(gridElement) as dxDataGrid;
          grid?.clearSelection();
        }
      }, 0);
    };

    const observer = new MutationObserver(() => {
      const checkbox = gridElement.querySelector(
        ".dx-header-row .dx-select-checkbox"
      );
      if (checkbox) {
        checkbox.removeEventListener("click", handleClick);
        checkbox.addEventListener("click", handleClick);
      }
    });

    observer.observe(gridElement, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      const checkbox = gridElement.querySelector(
        ".dx-header-row .dx-select-checkbox"
      );
      checkbox?.removeEventListener("click", handleClick);
    };
  }, [gridId, activate]);
}
